<template>
  <div v-show="position.show" :style="fontStyle">
    <div v-if="option.directionAlignment === 1">
      <span :style="prefixStyle">{{ option.prefixData }}</span>
      <span
        v-if="Number(option.data) < option.criticalValue && option.sign"
        :style="option.floatColor ? arrowStyleGreen : arrowStyle"
        >-</span
      >
      <span
        v-if="Number(option.data) > option.criticalValue && option.sign"
        :style="option.floatColor ? arrowStyleRed : arrowStyle"
        >+</span
      >
      <span
        v-if="option.floatColor && option.arrowRedOrGreen === false"
        :style="Number(option.data) > option.criticalValue ? arrowStyleRed : arrowStyleGreen"
      >
        {{ textData | dataFormat(option.minIntLength, option.thousandsSeparator) }}
      </span>
      <span v-else>
        {{ textData | dataFormat(option.minIntLength, option.thousandsSeparator) }}
      </span>
      <span :style="suffixStyle">{{ option.suffixData }}</span>
      <span
        v-if="Number(option.data) < option.criticalValue && option.arrowIsTrue"
        :style="option.floatColor ? arrowStyleGreen : arrowStyle"
        >↓</span
      >
      <span
        v-if="Number(option.data) > option.criticalValue && option.arrowIsTrue"
        :style="option.floatColor ? arrowStyleRed : arrowStyle"
        >↑</span
      >
    </div>
    <div v-else>
      <span style="display:block;" :style="prefixStyle">{{ option.prefixData }}</span>
      <span
        style="display:block;"
        v-if="Number(option.data) < option.criticalValue && option.sign"
        :style="option.floatColor ? arrowStyleGreen : arrowStyle"
        >-</span
      >
      <span
        style="display:block;"
        v-if="Number(option.data) > option.criticalValue && option.sign"
        :style="option.floatColor ? arrowStyleRed : arrowStyle"
        >+</span
      >
      <span
        style="display:block;"
        v-if="option.floatColor && option.arrowRedOrGreen === false"
        :style="Number(option.data) > option.criticalValue && option.arrowIsTrue ? arrowStyleRed : arrowStyleGreen"
      >
        {{ textData | dataFormat(option.minIntLength, option.thousandsSeparator) }}
      </span>
      <span style="display:block;" v-else>
        {{ textData | dataFormat(option.minIntLength, option.thousandsSeparator) }}
      </span>
      <span style="display:block;" :style="suffixStyle">{{ option.suffixData }}</span>
      <span
        style="display:block;"
        v-if="Number(option.data) < option.criticalValue && option.arrowIsTrue"
        :style="option.floatColor ? arrowStyleGreen : arrowStyle"
        >↓</span
      >
      <span
        style="display:block;"
        v-if="Number(option.data) > option.criticalValue && option.arrowIsTrue"
        :style="option.floatColor ? arrowStyleRed : arrowStyle"
        >↑</span
      >
    </div>
  </div>
</template>

<script>
// import { mapState } from 'vuex'
// import HIcon from '@/components/HIcon'

export default {
  // 导航配置组件
  name: 'PercentageIndicator',
  components: {
    // HIcon
  },
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    position: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  filters: {
    dataFormat(textData, minIntLength, thousandsSeparator) {
      if (thousandsSeparator) {
        // 开启千位符
        let zeroLength = 0
        let zeroString = ''
        if (textData.length < minIntLength) {
          const textArr = textData.split('')
          zeroLength = minIntLength - textData.length
          for (let i = 0; i < zeroLength; i++) {
            textArr.unshift('0')
          }
          zeroString = textArr.join('')
          var str1 = ''
          for (var i = zeroString.length - 1, j = 1; i >= 0; i--, j++) {
            if (j % 3 === 0 && i !== 0) {
              str1 += zeroString[i] + ','
              continue
            }
            str1 += zeroString[i]
          }
          return str1
            .split('')
            .reverse()
            .join('')
        } else {
          var str = ''
          for (var m = textData.length - 1, n = 1; m >= 0; m--, n++) {
            if (n % 3 === 0 && m !== 0) {
              str += textData[m] + ','
              continue
            }
            str += textData[m]
          }
          return str
            .split('')
            .reverse()
            .join('')
        }
      } else {
        // 关闭千位符
        console.log('关闭了')
        let zeroLength = 0
        let zeroString = ''
        if (textData.length < minIntLength) {
          const textArr = textData.split('')
          zeroLength = minIntLength - textData.length
          for (let i = 0; i < zeroLength; i++) {
            textArr.unshift('0')
          }
          zeroString = textArr.join('')
          console.log('数组', zeroString, textArr)
          return zeroString
        } else {
          const textArr = textData.split('')
          console.log('数组', textData, textArr)
          return textData
        }
      }
    }
  },
  computed: {
    fontStyle() {
      const fontstyle = {
        'font-size': `${this.option.fontSize}px`,
        'text-align': `${this.option.textAlign}`,
        color: this.option.color,
        // 'font-weight': this.option.fontWeight ? 'bold' : 'normal',
        'background-color': this.option.backgroundColor
        // 'line-height': `${this.position.h}px`,
      }
      return fontstyle
    },
    // 数字间隔
    optionStyle() {
      const fontstyle = {
        'margin-right': `${this.option.numberMargin}px`
      }
      return fontstyle
    },
    // 箭头样式
    arrowStyle() {
      const fontstyle = {
        'font-size': `${this.option.arrowSize}px`,
        'margin-left': `${this.option.arrowMarginLeft}px`, // 水平时
        'margin-Top': `${this.option.arrowMarginTop}px` // 垂直时
      }
      return fontstyle
    },
    // 飘红箭头颜色
    arrowStyleRed() {
      const fontstyle = {
        color: this.option.redColorFloating,
        'font-size': `${this.option.arrowSize}px`, // 箭头大小
        'margin-left': `${this.option.arrowMarginLeft}px`, // 水平时 箭头与主体的距离
        'margin-top': `${this.option.arrowMarginTop}px` // 垂直时 箭头与主题的距离
      }
      return fontstyle
    },
    // 飘绿箭头颜色
    arrowStyleGreen() {
      const fontstyle = {
        color: this.option.greenColorFloating,
        'font-size': `${this.option.arrowSize}px`, // 箭头大小
        'margin-left': `${this.option.arrowMarginLeft}px`, // 水平时 箭头与主体的距离
        'margin-top': `${this.option.arrowMarginTop}px` // 垂直时 箭头与主题的距离
      }
      return fontstyle
    },
    // 前缀样式
    prefixStyle() {
      const fontstyle = {
        'font-size': `${this.option.prefixFontSize}px`,
        color: this.option.prefixColor,
        'margin-right': `${this.option.marginPrefixRight}px`, // 水平时
        'margin-bottom': `${this.option.marginPrefixBottom}px` // 垂直时
      }
      return fontstyle
    },
    // 后缀样式
    suffixStyle() {
      const fontstyle = {
        'font-size': `${this.option.suffixFontSize}px`,
        color: this.option.suffixColor,
        'margin-left': `${this.option.marginSuffixLeft}px`, // 水平时
        'margin-top': `${this.option.marginSuffixTop}px` // 垂直时
      }
      return fontstyle
    },
    textData() {
      const data = this.option.data
      return data
    }
  }
}
</script>

<style scoped lang="less"></style>
